import React from 'react';
import './index.scss';

const FileQueueMsg = ({ className = '', queueCount }) => {
    return (
        <div className={`file-queue-blc ${className}`}>
            Queue Files: {queueCount}
        </div>
    )
}

export default FileQueueMsg;